var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWsteth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#00A3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.988 237.834L148.122 242.231C115.796 291.819 123.016 356.763 165.48 398.37C190.461 422.847 223.202 435.087 255.944 435.091C255.944 435.091 255.944 435.091 150.988 237.834Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M255.935 297.785L150.979 237.834C255.935 435.091 255.935 435.091 255.935 435.091C255.935 392.13 255.935 342.902 255.935 297.785Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M361.012 237.834L363.878 242.231C396.204 291.819 388.984 356.763 346.52 398.37C321.539 422.847 288.798 435.087 256.056 435.091C256.056 435.091 256.056 435.091 361.012 237.834Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M256.044 297.785L361 237.834C256.045 435.091 256.044 435.091 256.044 435.091C256.044 392.13 256.044 342.902 256.044 297.785Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M256.062 163.834V267.233L346.47 215.567L256.062 163.834Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M256.077 163.834L165.604 215.566L256.077 267.233V163.834Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M256.077 76.875L165.604 215.599L256.077 163.722V76.875Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M256.062 163.707L346.539 215.586L256.062 76.793V163.707Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsteth);
export default __webpack_public_path__ + "static/media/wsteth.ff95a580d694ee016ceb0ad40354ae26.svg";
export { ForwardRef as ReactComponent };